import React, { Fragment, useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import { useStyles } from "./styles";
import { get } from "lodash";
// import { useLazyQuery } from "@apollo/client";
import {
  Grid,
  InputBase,
  List,
  ListItem,
  ListItemText,
  Popover,
  Typography,
  CircularProgress,
  Tooltip,
} from "@material-ui/core";
import SearchListItem from "./SearchListItem";
import { useTranslation } from "react-i18next";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import { useMainTheme } from "../../hooks/useMainTheme";
import { getUserId } from "src/utils";
// import { FETCH_POLICY } from "../../constants";
// import { searchQuery } from "../../graphQL/queries/dashboard";
// import LearningCheckinNotificaionIcon from "Assets/images/learning-notification-icon.svg";
// import SurveyCheckinNotificaionIcon from "Assets/images/survey-checkin-notification-icon.svg";
// import SkillRatingCheckinNotificaionIcon from "Assets/images/skillrating-checkin-notification-icon.svg";
// import RequestFeedbackNotificationIcon from "Assets/images/request-feedback-search-icon.svg";
import { searchBar } from "Hooks/layout/searchBar";
import { useRecoilState } from "recoil";
import { inputEventState, searchOptionsState } from "Recoil/General/atom";
import { anchorElState } from "Recoil/Checkins/atom";

const SearchBar = ({ refreshHeader }) => {
  const styleProps = useMainTheme();
  const classes = useStyles(styleProps);
  const { t } = useTranslation();
  // const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl, setAnchorEl] = useRecoilState(anchorElState);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const [inputText, setInputText] = useState("");
  // const [searchOptions, setSearchOptions] = useState([]);
  const [searchOptions, setSearchOptions] = useRecoilState(searchOptionsState);
  // const [inputEvent, setInputEvent] = useState({});
  const [inputEvent, setInputEvent] = useRecoilState(inputEventState);
  const [inputClass, setInputClass] = useState({
    root: classes.inputRoot,
    input: `${classes.inputInput} ${inputText.length ? "expandInput" : ""}`,
  });

  // const [searchQueryData, { loading }] = useLazyQuery(searchQuery, {
  //   fetchPolicy: FETCH_POLICY.networkOnly,
  //   onCompleted: (data) => {
  //     const userData = get(data, "getCompany.users.items", []);
  //     const targetData = get(
  //       data,
  //       "getCompany.listTargetCustom.items.0.targets",
  //       []
  //     );
  //     const checkinData = get(data, "getCompany.checkinSearch.items", []);
  //     const SSorPRData = get(data, "getCompany.successStorySearch.items", []);
  //     const userSearchResult = userData.map((user) => {
  //       return {
  //         type: "User",
  //         id: get(user, "id", ""),
  //         image: `${(get(user, "profileImage.fileName", "") || "").length
  //           ? `${process.env.REACT_APP_CLOUD_FRONT_URL}/${get(
  //             user,
  //             "profileImage.fileName",
  //             ""
  //           )}`
  //           : ""
  //           }`,
  //         name: `${get(user, "firstName", "")} ${get(user, "lastName", "")}`,
  //       };
  //     });
  //     const targetSearchResult = targetData.map((target) => {
  //       return {
  //         type: "Target",
  //         id: get(target, "id", ""),
  //         image: `${(get(target, "logo.fileName", "") || "").length
  //           ? `${process.env.REACT_APP_CLOUD_FRONT_URL}/${get(
  //             target,
  //             "logo.fileName",
  //             ""
  //           )}`
  //           : ""
  //           }`,
  //         name: get(target, "title", ""),
  //       };
  //     });
  //     const successStorySearchResult = SSorPRData.map((ssorpr) => {
  //       return {
  //         type: "SuccessStory",
  //         id: get(ssorpr, "id", ""),
  //         name: get(ssorpr, "title", ""),
  //         isPerformanceReview: get(ssorpr, "isPerformanceReview", ""),
  //       };
  //     });
  //     const checkinSearchResult = checkinData.map((checkin) => {
  //       let image = "";
  //       const type = get(checkin, "checkInType", "");
  //       switch (type) {
  //         case "LEARNING":
  //           image = LearningCheckinNotificaionIcon;
  //           break;
  //         case "SURVEY":
  //           image = SurveyCheckinNotificaionIcon;
  //           break;
  //         case "SKILLRATING":
  //           image = SkillRatingCheckinNotificaionIcon;
  //           break;
  //         case "REQUESTFEEDBACK":
  //           image = RequestFeedbackNotificationIcon;
  //         default:
  //           break;
  //       }
  //       return {
  //         type: "Checkin",
  //         id: get(checkin, "id", ""),
  //         image,
  //         name: get(checkin, "name", ""),
  //         targetId: get(checkin, "checkInTargetId", ""),
  //       };
  //     });
  //     setSearchOptions([
  //       ...userSearchResult,
  //       ...targetSearchResult,
  //       ...checkinSearchResult,
  //       ...successStorySearchResult,
  //     ]);
  //     setAnchorEl(inputEvent);
  //     // setInputText("");
  //   },
  // });

  const {searchQueryData,  loading } = searchBar();
  const searchQueryFunction = (searchText) => {
    searchQueryData({
      variables: {
        id: get(Auth, "user.attributes.custom:companyId", ""),
        searchText,
        targetSelection: "HeaderSearch",
        userId: getUserId(),
        listFilter: {
          userId: getUserId(),
          dataState: {},
          filterKey: "headerSearch",
        },
      },
    });
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      const { value } = get(event, "target", "");
      setInputText(value);
      searchQueryFunction(value.toLowerCase());
    }
  };

  const inputClasses = () =>
    setInputClass({
      root: classes.inputRoot,
      input: `${classes.inputInput} ${inputText.length ? "expandInput" : ""}`,
    });

  useEffect(() => {
    inputClasses();
  }, [inputText]);

  const handleClose = () => {
    inputClasses();
    setAnchorEl(null);
  };

  useEffect(() => {
    setInputText("");
  }, []);

  useEffect(() => {
    setInputText("");
  }, [refreshHeader]);

  return (
    <Fragment>
      <InputBase
        data-testid="onchange"
        id={id}
        aria-describedby={id}
        placeholder={t("dashboard.search")}
        classes={inputClass}
        onKeyPress={handleKeyPress}
        value={inputText}
        onChange={(e) => {
          const { value } = get(e, "target");
          if (value.length >= 3) {
            searchQueryFunction(value.toLowerCase());
            setInputClass({
              root: classes.inputRoot,
              input: `${classes.inputInput} expandInput`,
            });
          }
          setInputText(value);
          setInputEvent(e.currentTarget);
        }}
        InputProps={{
          "aria-label": "search",
        }}
        startAdornment={loading ? null : <Tooltip title="Search"><SearchOutlinedIcon /></Tooltip>}
        endAdornment={
          <div className={classes.searchbarLoader}>
            {loading ? <CircularProgress /> : null}
          </div>
        }
      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <List className={classes.popoverList}>
          {searchOptions.length ? (
            <Fragment>
              {(searchOptions || []).map((notification, i) => {
                return (
                  <SearchListItem
                    key={i}
                    notification={notification}
                    setSearchOptions={setSearchOptions}
                    setInputText={setInputText}
                    setAnchorEl={setAnchorEl}
                  />
                );
              })}
            </Fragment>
          ) : (
            <ListItem>
              <ListItemText>
                <Grid container xs={12}>
                  <Typography variant="body2" className="font-13">
                    {t("dashboard.noDataFound")}
                  </Typography>
                </Grid>
              </ListItemText>
            </ListItem>
          )}
        </List>
      </Popover>
    </Fragment>
  );
};
export default SearchBar;
